import PolicyLayout from './PolicyLayout';
import {
  ADDRESS,
  COMPANY_NAME,
  LEGAL_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
} from '../constants/site';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      updated={LEGAL_UPDATED}
      intro={`This Privacy Policy explains how ${COMPANY_NAME} (${ADDRESS}), operator of ${SITE_DOMAIN} (${SITE_NAME}), collects, uses, stores, and protects personal information when you browse our website, contact support, or purchase design software or digital marketing software through us.`}
    >
      <h2>Information we collect</h2>
      <p>
        We only collect information that helps us complete your order and provide
        support. Depending on how you interact with us, this may include:
      </p>
      <ul>
        <li>
          <strong>Contact details</strong> — name, email address, and telephone
          number when you call, submit a form, or email us.
        </li>
        <li>
          <strong>Order information</strong> — categories purchased, licence
          seats, billing address, and transaction reference. We never store full
          payment card numbers.
        </li>
        <li>
          <strong>Support records</strong> — notes from a support session,
          including operating system and software category involved.
        </li>
        <li>
          <strong>Technical data</strong> — IP address, browser type, device
          category, referring page, and general location for security and
          analytics.
        </li>
      </ul>

      <h2>How we use your information</h2>
      <p>Information collected through this website is used to:</p>
      <ul>
        <li>Process orders and deliver download links and activation steps.</li>
        <li>Provide installation assistance for design and marketing tools.</li>
        <li>Send transactional messages such as receipts and service notices.</li>
        <li>Detect and prevent fraud, abuse, and security incidents.</li>
        <li>Improve website content, performance, and customer experience.</li>
      </ul>
      <p>
        We do not sell, rent, or trade your personal information to third parties
        for their own marketing purposes.
      </p>

      <h2>Payment processing</h2>
      <p>
        Payments are handled by PCI-DSS compliant third-party processors. Card
        details are transmitted directly to the processor over an encrypted
        connection and are never stored on our servers.
      </p>

      <h2>Cookies and tracking</h2>
      <p>
        We use a small number of cookies to keep the site functioning, remember
        preferences, and understand which pages are useful. Analytics cookies are
        aggregated and do not identify you personally. You can block cookies in
        your browser settings.
      </p>

      <h2>Data sharing</h2>
      <p>We share information only when needed to:</p>
      <ul>
        <li>Fulfil a licence or download you purchased.</li>
        <li>
          Work with providers who host our website, process payments, or deliver
          email, all bound by confidentiality obligations.
        </li>
        <li>
          Comply with law, court order, or a legitimate regulatory request.
        </li>
      </ul>

      <h2>Retention</h2>
      <p>
        Order and support records are kept for as long as needed to provide
        service, meet legal obligations, and resolve disputes. You may request
        deletion of account-related personal data where the law allows.
      </p>

      <h2>Your rights</h2>
      <p>
        Depending on your location, you may have rights to access, correct,
        delete, or restrict processing of your personal data. Contact{' '}
        {SUPPORT_EMAIL} to make a request.
      </p>

      <h2>Changes</h2>
      <p>
        We may update this Privacy Policy from time to time. The “Last updated”
        date at the top of this page reflects the latest revision.
      </p>
    </PolicyLayout>
  );
}
